<template>
  <div>
    <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Evolução</h1>
    <data-table
      v-if="loadTable"
      v-model:columns="columns"
      :route="'/patients/evolutions/' + patient.id"
      no-data-label="Nenhuma evolução cadastrada"
      no-result-label="Nenhuma evolução encontrada"
    >
      <template #table.cell.content.actions="{ value, row }">
        <div class="inline-grid grid-cols-2 gap-4 ">
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
        </div>
      </template>
      <template #grid.content.body.actions="{ value, row }">
        <div class="inline-grid grid-cols-2 gap-4 ">
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalEdit(row)"><font-awesome-icon icon="fa-pen-to-square" class="text-blue-500 text-lg cursor-pointer" /></span>
          <span v-if="user.role == 1 || row.professional_id == user.professional.id" @click="openModalConfirmDelete(row)"><font-awesome-icon icon="fa-trash-can" class="text-red-600 text-lg cursor-pointer" /></span>
        </div>
      </template>

      <template #after.reload-button>
        <button v-if="user.role == 2" class="flex items-end font-roboto font-medium btn-blue uppercase" @click.prevent="openModalEdit({})">
          <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" /><span class="hidden lg:block"> Adicionar Evolução</span>
        </button>
      </template>
    </data-table>
  </div>
  <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>
  <modal-edit ref="modalEdit" title="Dado Vital" :url="'patients/evolutions/' + patient.id" @submitForm="reloadTable">
    <template #form="{item}">
      <text-input v-model="item.title" :error="item.errors.title" class="lg:pr-6 w-full lg:w-1/2" label="Título" />
      <date-time-input v-model="item.date" :error="item.errors.date" class="mt-6 lg:mt-0 w-full lg:w-1/2" label="Data e hora" />
      <vue-select-input v-if="user.role == 1" :getOptionLabel="(professional) => professional.user?.name" v-model="item.professional" :options="this.professionals()" :error="item.errors[`professional.id`]" class="mt-6 w-full" label="Profissional" text="nenhum profissional encontrado" />
      <textarea-input v-model="item.description" :error="item.errors.description" class="mt-6 w-full" label="Descrição" />
    </template>
  </modal-edit>
</template>

<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import LoadingButton from '@/Shared/LoadingButton'
import ModalDelete from '@/Shared/ModalDelete'
import ModalEdit from '@/Shared/ModalEdit'
import DataTable from '@/Shared/DataTable'
import DateTimeInput from '@/Shared/DateTimeInput'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import VueSelectInput from '@/Shared/VueSelectInput'

export default {
  inject: ['patient', 'professionals'],
  components: {
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    DateTimeInput,
    TextInput,
    TextareaInput,
    VueSelectInput,
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  data() {
    return {
      loadTable: true,
      columns: [
        {
          uniqid: 'evolution_title',
          label: 'Título',
          field: 'title',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'evolution_description',
          label: 'Descrição',
          field: 'description',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm overflow-hidden',
          headerClass: 'p-4 text-left',
          format: (val, row) => val ? val.substr(0, 50) : ''
        },
        {
          uniqid: 'evolution_date',
          label: 'Data',
          field: 'date',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDateTime(row.date),
        },
        {
          uniqid: 'evolution_professional',
          label: 'Profissional',
          field: 'professional_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.id ? row.professional.user.name : ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: this.user.role == 2 ? true : false,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },
  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/patients/evolutions/${item.id}`, `Deseja realmente excluir a evolução ${item.title}?`);
    },
    openModalEdit(item) {
      this.$refs.modalEdit.openModalEdit({
        id: item.id,
        title: item.title,
        description: item.description,
        date: item.date,
        professional: item.professional ?? null,
      });
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    }
  },
}
</script>